import React, { useState } from "react"
// import ImagingSearchAccordion from "../../../ImagingSearchAccordion/ImagingSearchAccordion";
import { useHistory } from "react-router-dom"

import SearchIcon from "../../../../../Assets/svg/search-grey.svg"
import mobileSearchStyles from "./MobileSearch.module.css"

const MobileSearch = () => {
  const history = useHistory();
  // const [showSearchAccordion, setShowSearchAccordion] = useState(false);

  const handleSearchClick = () => {
    history.push("/imaging/search")
  }

  return (
    <>
      {!history.location.pathname.includes("/search")
        ? <div className={mobileSearchStyles.inputbAR}>
          <img src={SearchIcon} className={mobileSearchStyles.searchIcon} />
          <input
            type="button"
            onClick={handleSearchClick}
            defaultValue="Search Tests, MRI, XRAY.."
           />
        </div>
        : null}
      {/* {showSearchAccordion
        ? <ImagingSearchAccordion setShowSearchAccordion={setShowSearchAccordion} />
        : null
      } */}
    </>
  )
}

export default MobileSearch;